import { render } from "./SoundtracksView.vue?vue&type=template&id=21984f6d"
import script from "./SoundtracksView.vue?vue&type=script&lang=js"
export * from "./SoundtracksView.vue?vue&type=script&lang=js"

import "./SoundtracksView.vue?vue&type=style&index=0&id=21984f6d&lang=css"

import exportComponent from "C:\\Programowanie\\Projects\\last38minutes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__